/* DigitalPulse Bildreichweite: beobachtet markierte Bilder und meldet Sichtkontakte
   als Shopify Custom Events. Keine Cookies, keine Personendaten. */
(function (root) {
  'use strict';

  var SEEN_MS = 1000;
  var VIEWED_MS = 3000;
  var RATIO = 0.5;
  var SLOT = /^[A-Za-z0-9_-]{1,120}(\/[A-Za-z0-9_-]{1,120})?$/;
  var IMAGE = /^[0-9]{1,20}$/;
  var MAX_ITEMS = 50;
  var MARK = '[data-dp-slot][data-dp-image]';
  var CONSENT_FALLBACK_MS = 3000;
  var CONSENT_EVENT_DELAYS_MS = [1500, 4000, 8000];
  var CONSENT_BOOT_REPLAY_DELAYS_MS = [2500, 6000, 10000];
  // IntersectionObserver-Schwellen, dicht nur bei kleinen Ratios: bei einem hohen Bild (Höhe H > Viewport
  // V) entspricht 50 % Viewport-Abdeckung einem intersectionRatio von nur 0,5 · V / H (3 × V → 0,17,
  // 10 × V → 0,05). Ohne feine Schwellen im unteren Bereich feuerte der Callback nach dem Eintritt nicht
  // mehr. Bleibt der Scroll zwischen zwei Schwellen stehen, feuert IO trotzdem nicht — dafür rechnet der
  // Scroll-Pfad (registry.recomputeTall) hohe, schneidende Elemente je Frame nach.
  var IO_THRESHOLDS = [0, 0.01, 0.02, 0.03, 0.04, 0.05, 0.06, 0.07, 0.08, 0.09, 0.1,
    0.125, 0.15, 0.2, 0.25, 0.3, 0.4, 0.5, 0.75, 1];

  // Sichtbarkeitsdefinition („Sichtkontakt“): ein Bild gilt als sichtbar, wenn ≥ 50 % seiner Fläche im
  // Viewport liegen. Nur für Bilder, die höher als der Viewport sind, gilt zusätzlich die
  // Viewport-Abdeckung: (sichtbare Höhe ÷ Viewport-Höhe) × (sichtbare Breite ÷ Bildbreite) ≥ 50 % —
  // also Anteil der Viewport-Höhe, gewichtet mit dem sichtbaren Breitenanteil. Damit sind Bilder höher als
  // 2 × Viewport messbar (sie erreichen nie 50 % eigene Fläche), während seitlich angeschnittene
  // Karussell-Slides (z. B. 15 % Breite sichtbar, volle Höhe) bei normaler Höhe nur über
  // intersectionRatio zählen und nicht als gesehen gelten.
  // Gemeinsame Rechenregel für IO-Pfad und Scroll-Pfad: sichtbare Breite/Höhe, Elementmaße und
  // Viewport-Höhe → effektives Ratio (0..1). areaRatio optional (IO liefert intersectionRatio selbst).
  function ratioFromVisible(visW, visH, width, height, vh, areaRatio) {
    var area = typeof areaRatio === 'number' ? areaRatio
      : (width > 0 && height > 0 ? (visW * visH) / (width * height) : 0);
    if (!(vh > 0) || !(height > vh)) return Math.min(1, Math.max(0, area));
    var coverage = width > 0 && visW > 0 ? (visH / vh) * (visW / width) : 0;
    return Math.min(1, Math.max(0, area, coverage));
  }

  // Reine Hilfsfunktion für den Scroll-Pfad: Element-Rechteck (getBoundingClientRect) ∩ Viewport
  // (vw × vh) → effektives Ratio. maxWidthShare (optional, 0..1) begrenzt den sichtbaren Breitenanteil auf
  // den zuletzt von IntersectionObserver gemeldeten — IO berücksichtigt Clipping durch Vorfahren
  // (overflow: hidden im Karussell), das reine Viewport-Geometrie nicht sieht.
  function coverageFromRects(rectTop, rectBottom, rectLeft, rectRight, width, height, vw, vh, maxWidthShare) {
    var visH = Math.max(0, Math.min(rectBottom, vh) - Math.max(rectTop, 0));
    var visW = Math.max(0, Math.min(rectRight, vw) - Math.max(rectLeft, 0));
    if (typeof maxWidthShare === 'number' && width > 0) visW = Math.min(visW, maxWidthShare * width);
    if (visH <= 0 || visW <= 0) return 0;
    return ratioFromVisible(visW, visH, width, height, vh);
  }

  function rootHeightOf(entry, fallbackHeight) {
    return entry && entry.rootBounds ? entry.rootBounds.height : fallbackHeight;
  }

  // IO-Meldung eines hohen, schneidenden Elements (höher als der Viewport) → sichtbarer Breitenanteil
  // (für den Scroll-Pfad), sonst null.
  function tallInfo(entry, fallbackHeight) {
    if (!entry || !entry.isIntersecting || !entry.boundingClientRect) return null;
    var vh = rootHeightOf(entry, fallbackHeight);
    var box = entry.boundingClientRect;
    if (!(vh > 0) || !(box.height > vh)) return null;
    var w = entry.intersectionRect ? entry.intersectionRect.width : 0;
    return { widthShare: box.width > 0 ? Math.min(1, w / box.width) : 0 };
  }

  // Reine Hilfsfunktion: IntersectionObserverEntry → effektives Ratio (0..1).
  function effectiveRatio(entry, fallbackHeight) {
    if (!entry || !entry.isIntersecting) return 0;
    var box = entry.boundingClientRect;
    var rect = entry.intersectionRect;
    var ratio = entry.intersectionRatio || 0;
    if (!box || !rect) return Math.min(1, ratio);
    return ratioFromVisible(rect.width, rect.height, box.width, box.height, rootHeightOf(entry, fallbackHeight), ratio);
  }

  function createTracker(deps) {
    var entries = [];
    var byEl = new Map();
    var byKey = new Map();

    function emit(name, e) { deps.publish(name, { slot: e.slot, image: e.image }); }

    // „Betrachtet“ (kumuliert 3 s) setzt einen Sichtkontakt (1 s am Stück) voraus. Wird die 3-s-Schwelle
    // aus kurzen Einzelstrecken erreicht, bevor ein Sichtkontakt zustande kam, wird viewed zurückgehalten
    // und direkt nach dem Sichtkontakt gemeldet — sonst verwirft DigitalPulse die erste Sendung.
    function emitViewedIfSeen(e) {
      if (!e.viewed || !e.seen || e.viewedSent) return;
      e.viewedSent = true;
      emit('dp_image_viewed', e);
    }

    function stopStretch(e) {
      if (e.visibleSince === null) return;
      e.total += deps.now() - e.visibleSince;
      e.visibleSince = null;
      if (e.seenTimer) { deps.clearTimer(e.seenTimer); e.seenTimer = null; }
      if (e.viewTimer) { deps.clearTimer(e.viewTimer); e.viewTimer = null; }
    }

    function startStretch(e) {
      if (e.visibleSince !== null) return;
      e.visibleSince = deps.now();
      if (!e.seen) {
        e.seenTimer = deps.setTimer(function () { e.seenTimer = null; e.seen = true; emit('dp_image_seen', e); emitViewedIfSeen(e); }, SEEN_MS);
      }
      if (!e.viewed) {
        e.viewTimer = deps.setTimer(function () { e.viewTimer = null; e.viewed = true; emitViewedIfSeen(e); }, Math.max(0, VIEWED_MS - e.total));
      }
    }

    function inventory(page) {
      deps.publish('dp_image_inventory', {
        page: { type: page.type, handle: page.handle },
        items: entries.map(function (e) { return { slot: e.slot, image: e.image, pos: e.pos }; }),
      });
    }

    // Platzierung zu Slot+Bild finden oder anlegen; null bei ungültigen Attributen oder voller Obergrenze.
    function entryFor(slot, image) {
      if (typeof slot !== 'string' || !SLOT.test(slot) || typeof image !== 'string' || !IMAGE.test(image)) return null;
      // Swiper (loop:true) klont Slides samt Attributen: gleicher Slot+Bild = dieselbe Platzierung.
      var key = slot + '|' + image;
      var e = byKey.get(key);
      if (!e) {
        if (entries.length >= MAX_ITEMS) return null;
        e = { slot: slot, image: image, pos: entries.length + 1, seen: false, viewed: false, viewedSent: false, clicked: false,
          visibleSince: null, total: 0, seenTimer: null, viewTimer: null, visibleEls: new Set() };
        entries.push(e);
        byKey.set(key, e);
      }
      return e;
    }

    return {
      register: function (el, slot, image) {
        if (byEl.has(el)) return false;
        var e = entryFor(slot, image);
        if (!e) return false;
        byEl.set(el, e);
        return true;
      },
      // Element aus dem DOM entfernt (z. B. Swiper-Klon nach Breakpoint-Neuinitialisierung): zählt
      // nicht mehr zur Sichtbarkeit seiner Platzierung. War es
      // das letzte sichtbare Element, endet die Strecke (laufende Sichtkontakt-/Betrachtet-Timer stoppen).
      // Erreichte Flags der Platzierung bleiben erhalten.
      forget: function (el) {
        var e = byEl.get(el);
        if (!e) return;
        byEl.delete(el);
        e.visibleEls.delete(el);
        if (e.visibleEls.size === 0) stopStretch(e);
      },
      inventory: inventory,
      // Nach erteiltem Consent: das Pixel lädt erst dann und hat das erste Inventar verpasst. Inventar
      // erneut senden und alle bereits erreichten Flags nachreichen; das Pixel dedupliziert über seine
      // eigenen Sende-Markierungen, jede Sendung enthält jedes Flag also höchstens einmal.
      replay: function (page) {
        inventory(page);
        entries.forEach(function (e) {
          if (e.seen) emit('dp_image_seen', e);
          if (e.viewedSent) emit('dp_image_viewed', e);
          if (e.clicked) emit('dp_image_click', e);
        });
      },
      visibility: function (el, ratio) {
        var e = byEl.get(el);
        if (!e) return;
        // Fade-Karussells (Swiper effect:'fade') halten alle Slides an derselben Stelle; inaktive Slides
        // sind nur per Opacity ausgeblendet, was IntersectionObserver ignoriert. deps.isActive gate das.
        var active = deps.isActive ? deps.isActive(el) : true;
        // ratio ist bereits das effektive Ratio aus effectiveRatio() (Fläche ODER Viewport-Abdeckung).
        var gated = active ? ratio : 0;
        if (gated >= RATIO) e.visibleEls.add(el); else e.visibleEls.delete(el);
        if (e.visibleEls.size > 0) startStretch(e); else stopStretch(e);
      },
      click: function (el) {
        var e = byEl.get(el);
        if (!e || !e.seen || e.clicked) return;
        e.clicked = true;
        emit('dp_image_click', e);
      },
    };
  }

  // Reine Hilfsfunktion (auch für Tests ohne DOM): Nicht-Duplikate zuerst, Duplikate danach,
  // jeweils in stabiler Reihenfolge. Swiper (loop:true) legt bei Slide 8 (v9) den Klon der letzten
  // Slide VOR Slide 1 ins DOM; ohne diese Sortierung bekäme der Klon Position 1 statt die echte Slide.
  function partitionByDuplicate(nodes, isDuplicate) {
    var originals = [];
    var duplicates = [];
    for (var i = 0; i < nodes.length; i++) {
      if (isDuplicate(nodes[i])) duplicates.push(nodes[i]);
      else originals.push(nodes[i]);
    }
    return originals.concat(duplicates);
  }

  // Klick → markiertes Element. Reihenfolge:
  // 1. direkter Treffer auf ein markiertes Element (oder darin);
  // 2. Slideshow-Overlay („image_link_full“): ein separates <a class="slideshow__image-link"> liegt über
  //    dem Bild und fängt den Klick ab → markiertes Element der umgebenden Slide;
  // 3. Karten (snippets/card-image.liquid): der Link „a.card-media--link“ umschließt Bild UND Text,
  //    markiert ist aber nur das Bild. Klick irgendwo im nächsten umschließenden Link zählt, wenn dieser
  //    genau ein markiertes Element enthält (bei mehreren ist die Zuordnung nicht eindeutig → kein Klick).
  // Andere Klicks (CTA-Buttons außerhalb von Links, Swiper-Drag, sonstige Controls) zählen bewusst nicht.
  function findMarkedElement(target) {
    if (!target || !target.closest) return null;
    var direct = target.closest(MARK);
    if (direct) return direct;
    var overlayLink = target.closest('.slideshow__image-link');
    if (overlayLink) {
      var slide = overlayLink.closest('.swiper-slide');
      return slide ? slide.querySelector(MARK) : null;
    }
    var link = target.closest('a, .card-media--link');
    if (!link) return null;
    var inLink = link.querySelectorAll(MARK);
    return inLink.length === 1 ? inLink[0] : null;
  }

  function isMarked(node) {
    return !!(node.hasAttribute && node.hasAttribute('data-dp-slot') && node.hasAttribute('data-dp-image'));
  }

  function eachMarked(node, fn) {
    if (!node || node.nodeType !== 1) return;
    if (isMarked(node)) fn(node);
    if (node.querySelectorAll) node.querySelectorAll(MARK).forEach(fn);
  }

  // MutationObserver-Auswertung (childList, subtree). Entfernte Knoten zuerst, dann hinzugefügte, je
  // Mutation in Reihenfolge. Nur tatsächlich abgehängte Elemente gelten als entfernt — Swiper verschiebt
  // Slides auch (entfernen + sofort wieder einhängen); die bleiben registriert.
  function applyMutations(mutations, onAdded, onRemoved) {
    for (var m = 0; m < mutations.length; m++) {
      var removed = mutations[m].removedNodes || [];
      for (var r = 0; r < removed.length; r++) {
        eachMarked(removed[r], function (el) { if (!el.isConnected) onRemoved(el); });
      }
      var added = mutations[m].addedNodes || [];
      for (var a = 0; a < added.length; a++) eachMarked(added[a], onAdded);
    }
  }

  // Verwaltet die registrierten DOM-Elemente zwischen IntersectionObserver/MutationObserver und Tracker.
  // deps: tracker, observe(el), unobserve(el), isHidden(), isMobile(), measure(el, widthShare) → Ratio
  // (Scroll-Pfad; aktuelles Ratio aus der Geometrie, null = nicht messbar).
  // isMobile() liefert den beim Start ermittelten Wert: die Bild-ID eines Elements wird einmal gewählt
  // und bleibt für den ganzen Seitenaufruf (kein Umhängen beim Drehen/Fenstergröße-Wechsel — das
  // zählte dasselbe Element sonst unter zwei Platzierungen).
  function createRegistry(deps) {
    var known = new Set();
    var ratios = new Map();
    // Hohe (> Viewport), laut letzter IO-Meldung schneidende Elemente → zuletzt gemeldeter Breitenanteil.
    // IO feuert nur beim Überschreiten einer Schwelle; bleibt der Scroll zwischen zwei Schwellen stehen,
    // rechnet recomputeTall() diese Elemente je Scroll-/Resize-Frame aus der Geometrie nach.
    var tall = new Map();

    // Separates Mobilbild (image_mobile) hat eine eigene Datei-ID; Umschaltpunkt wie <picture> im Theme.
    function imageFor(el) {
      return (deps.isMobile() && el.getAttribute('data-dp-image-mobile')) || el.getAttribute('data-dp-image');
    }
    function effective(el) { return deps.isHidden() ? 0 : (ratios.get(el) || 0); }

    function add(el) {
      if (known.has(el)) return;
      known.add(el);
      deps.tracker.register(el, el.getAttribute('data-dp-slot'), imageFor(el));
      deps.observe(el);
    }

    function remove(el) {
      if (!known.has(el)) return;
      deps.tracker.forget(el);
      deps.unobserve(el);
      known.delete(el);
      ratios.delete(el);
      tall.delete(el);
    }

    return {
      add: add,
      remove: remove,
      has: function (el) { return known.has(el); },
      // IntersectionObserver-Meldung. Im Hintergrund-Tab zählt nichts als sichtbar. info = tallInfo(entry):
      // gesetzt → Element in den Scroll-Pfad aufnehmen, null → herausnehmen.
      intersect: function (el, ratio, info) {
        if (!known.has(el)) return;
        if (info) tall.set(el, info.widthShare); else tall.delete(el);
        ratios.set(el, ratio);
        deps.tracker.visibility(el, effective(el));
      },
      // Scroll-/Resize-Frame: hohe, schneidende Elemente aus der aktuellen Geometrie neu bewerten
      // (gleiche Regel wie im IO-Pfad; versteckter Tab → 0, Fade-Gate im Tracker).
      recomputeTall: function () {
        tall.forEach(function (widthShare, el) {
          if (!el.isConnected) { remove(el); return; }
          var r = deps.measure ? deps.measure(el, widthShare) : null;
          if (typeof r !== 'number') return;
          ratios.set(el, r);
          deps.tracker.visibility(el, effective(el));
        });
      },
      tallSize: function () { return tall.size; },
      isTall: function (el) { return tall.has(el); },
      // Fade-Klassenwechsel: mit dem zuletzt bekannten Ratio neu bewerten (0 bei verstecktem Tab).
      reapply: function (el) {
        if (known.has(el) && ratios.has(el)) deps.tracker.visibility(el, effective(el));
      },
      // Tab-Wechsel: abgehängte Elemente abräumen (Tracker vergisst sie → Strecke stoppt),
      // für die übrigen das zuletzt bekannte Ratio bzw. 0 anwenden.
      visibilityChanged: function () {
        known.forEach(function (el) {
          if (!el.isConnected) { remove(el); return; }
          deps.tracker.visibility(el, effective(el));
        });
      },
    };
  }

  // Spike 2026-09-27: Events, die vor dem Laden des Pixels publiziert werden, kommen nur an, wenn der
  // Consent schon bestand. Auf der Seite, auf der gerade eingewilligt wird, lädt das Pixel erst danach
  // → Inventar und erreichte Flags nachreichen (tracker.replay):
  // - bei jedem Shopify-Ereignis „visitorConsentCollected“ mit Analytics-Freigabe: sofort UND verzögert
  //   nach +1,5 s, +4 s und +8 s — beim Ereignis lädt die Pixel-Sandbox meist noch; puffert Shopify die
  //   Events zwischen Consent und Pixel-Start nicht, erreichen erst die verzögerten Replays das Pixel;
  // - bestand die Freigabe schon beim Start: +2,5 s, +6 s und +10 s nach dem Start (zusätzlich zum
  //   ersten Inventar), damit ein spät ladendes Pixel das Inventar trotzdem erhält;
  // - sonst Fallback einmalig ~3 s nach dem Start, falls die Freigabe inzwischen besteht und kein
  //   Ereignis kam (das Ereignis plant seine eigenen verzögerten Replays).
  // Mehrfache Replays sind unschädlich: das Pixel führt Inventare zusammen und sendet jedes Flag einmal.
  // deps: replay(), onConsentCollected(fn(detail)), analyticsAllowed() → bool, setTimer(fn, ms).
  function wireConsentReplay(deps) {
    function allowed() {
      try { return deps.analyticsAllowed() === true; } catch (err) { return false; }
    }
    var replayedByEvent = false;
    deps.onConsentCollected(function (detail) {
      if (detail && detail.analyticsAllowed === false) return;
      replayedByEvent = true;
      deps.replay();
      CONSENT_EVENT_DELAYS_MS.forEach(function (ms) { deps.setTimer(deps.replay, ms); });
    });
    if (allowed()) {
      CONSENT_BOOT_REPLAY_DELAYS_MS.forEach(function (ms) { deps.setTimer(deps.replay, ms); });
      return;
    }
    deps.setTimer(function () {
      if (!replayedByEvent && allowed()) deps.replay();
    }, CONSENT_FALLBACK_MS);
  }

  function boot() {
    var ctx = root.document && root.document.getElementById('dp-image-reach-context');
    if (!ctx || !root.IntersectionObserver) return;
    // Spike 2026-09-27: Shopify.analytics entsteht erst nach content_for_header asynchron.
    if (!(root.Shopify && root.Shopify.analytics && typeof root.Shopify.analytics.publish === 'function')) {
      var waited = boot.waited = (boot.waited || 0) + 10;
      if (waited <= 10000) root.setTimeout(boot, 10);
      return;
    }
    var page;
    try { page = JSON.parse(ctx.textContent); } catch (err) { return; }
    var doc = root.document;

    // Sichtbarkeit in Fade-Karussells (z. B. Section "slideshow"): eine im DOM nicht aktive Slide
    // liegt geometrisch an derselben Stelle wie die aktive und würde IntersectionObserver fälschlich
    // als sichtbar melden. Nur gaten, wenn der umgebende Swiper tatsächlich effect:'fade' fährt
    // (Swiper setzt dafür die Klasse "swiper-fade" auf den Swiper-Container); bei "slide"-Effekt
    // (card-images, lookbook-slider, slideshow-Layout "centered") ist die IO-Geometrie bereits korrekt.
    function isActive(el) {
      var slide = el.closest && el.closest('.swiper-slide');
      if (!slide) return true;
      var swiperRoot = slide.closest('.swiper');
      if (!swiperRoot || !swiperRoot.classList.contains('swiper-fade')) return true;
      return slide.classList.contains('swiper-slide-active') || slide.classList.contains('swiper-slide-visible');
    }

    var tracker = createTracker({
      now: function () { return root.performance.now(); },
      setTimer: function (fn, ms) { return root.setTimeout(fn, ms); },
      clearTimer: function (id) { root.clearTimeout(id); },
      publish: function (name, data) { root.Shopify.analytics.publish(name, data); },
      isActive: isActive,
    });

    // Einmal beim Start: max-width 767 px ⇒ Mobilbild (data-dp-image-mobile). Bleibt für den Seitenaufruf.
    var mobileAtBoot = !!(root.matchMedia && root.matchMedia('(max-width: 767px)').matches);
    var observedSwiperRoots = new WeakSet();

    var observer = new root.IntersectionObserver(function (list) {
      list.forEach(function (entry) {
        registry.intersect(entry.target, effectiveRatio(entry, root.innerHeight), tallInfo(entry, root.innerHeight));
      });
    }, { threshold: IO_THRESHOLDS });

    // Fade-Slides wechseln nur ihre Klassen (swiper-slide-active/-visible), nicht ihre Geometrie:
    // IntersectionObserver feuert dabei nicht neu. Klassenänderung am Swiper-Slide beobachten und mit
    // dem zuletzt bekannten IO-Ratio neu bewerten (deps.isActive greift dann sofort).
    var slideClassObserver = root.MutationObserver
      ? new root.MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          var slide = mutation.target;
          if (!slide.classList || !slide.classList.contains('swiper-slide')) return;
          slide.querySelectorAll(MARK).forEach(registry.reapply);
        });
      })
      : null;

    function observeSwiperRootFor(el) {
      if (!slideClassObserver) return;
      var slide = el.closest && el.closest('.swiper-slide');
      if (!slide) return;
      var swiperRoot = slide.closest('.swiper');
      if (!swiperRoot || observedSwiperRoots.has(swiperRoot)) return;
      observedSwiperRoots.add(swiperRoot);
      slideClassObserver.observe(swiperRoot, { attributes: true, attributeFilter: ['class'], subtree: true });
    }

    var registry = createRegistry({
      tracker: tracker,
      observe: function (el) { observer.observe(el); observeSwiperRootFor(el); },
      unobserve: function (el) { observer.unobserve(el); },
      isHidden: function () { return doc.visibilityState === 'hidden'; },
      isMobile: function () { return mobileAtBoot; },
      measure: function (el, widthShare) {
        if (!el.getBoundingClientRect) return null;
        var r = el.getBoundingClientRect();
        var vw = root.innerWidth || (doc.documentElement && doc.documentElement.clientWidth) || 0;
        var vh = root.innerHeight || (doc.documentElement && doc.documentElement.clientHeight) || 0;
        return coverageFromRects(r.top, r.bottom, r.left, r.right, r.width, r.height, vw, vh, widthShare);
      },
    });

    doc.addEventListener('click', function (evt) {
      var marked = findMarkedElement(evt.target);
      if (marked) tracker.click(marked);
    }, { passive: true });

    partitionByDuplicate(
      Array.prototype.slice.call(doc.querySelectorAll(MARK)),
      function (el) { return !!(el.closest && el.closest('.swiper-slide-duplicate')); }
    ).forEach(registry.add);
    tracker.inventory(page);

    // Swiper erzeugt Klone erst nach seiner Initialisierung und ersetzt sie bei einer Breakpoint-bedingten
    // Neuinitialisierung (card-images/lookbook-slider: slidesPerView-Wechsel bei 1024/1280 px, loop:true):
    // später hinzukommende Knoten nachregistrieren, entfernte vergessen (sonst hielte ein gelöschter,
    // zuletzt sichtbarer Klon seine Platzierung dauerhaft „sichtbar“). Dauerhaft aktiv, pro Mutation nur
    // billige Arbeit: ein hasAttribute-Check und ein auf den Knoten begrenztes querySelectorAll.
    // Neue Platzierungen erhalten Positionen hinter dem Inventar; sie werden beim nächsten Inventar
    // (Consent-Nachreichen) mitgemeldet.
    if (root.MutationObserver) {
      new root.MutationObserver(function (mutations) {
        applyMutations(mutations, registry.add, registry.remove);
      }).observe(doc.body, { childList: true, subtree: true });
    }

    // Tab-Wechsel: im Hintergrund zählt nichts; beim Zurückkehren die zuletzt bekannten Ratios wieder
    // anwenden, statt auf den nächsten Scroll zu warten. Abgehängte Elemente werden dabei vergessen.
    doc.addEventListener('visibilitychange', registry.visibilityChanged);

    // Scroll-Pfad für hohe Elemente (siehe registry.recomputeTall): ein passiver scroll- und
    // resize-Listener am window, per requestAnimationFrame auf einen Durchlauf je Frame gedrosselt.
    // Ohne hohe, schneidende Elemente passiert pro Event nur ein Size-Check.
    var framePending = false;
    var nextFrame = root.requestAnimationFrame
      ? function (fn) { root.requestAnimationFrame(fn); }
      : function (fn) { root.setTimeout(fn, 16); };
    function onScrollOrResize() {
      if (framePending || registry.tallSize() === 0) return;
      framePending = true;
      nextFrame(function () { framePending = false; registry.recomputeTall(); });
    }
    root.addEventListener('scroll', onScrollOrResize, { passive: true });
    root.addEventListener('resize', onScrollOrResize, { passive: true });

    wireConsentReplay({
      replay: function () { tracker.replay(page); },
      onConsentCollected: function (fn) {
        doc.addEventListener('visitorConsentCollected', function (evt) { fn(evt && evt.detail); });
      },
      analyticsAllowed: function () {
        var cp = root.Shopify && root.Shopify.customerPrivacy;
        return !!(cp && typeof cp.analyticsProcessingAllowed === 'function' && cp.analyticsProcessingAllowed());
      },
      setTimer: function (fn, ms) { return root.setTimeout(fn, ms); },
    });
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = {
      createTracker: createTracker,
      partitionByDuplicate: partitionByDuplicate,
      findMarkedElement: findMarkedElement,
      applyMutations: applyMutations,
      createRegistry: createRegistry,
      wireConsentReplay: wireConsentReplay,
      effectiveRatio: effectiveRatio,
      coverageFromRects: coverageFromRects,
      tallInfo: tallInfo,
      IO_THRESHOLDS: IO_THRESHOLDS,
    };
  } else if (root.document) {
    if (root.document.readyState === 'loading') root.document.addEventListener('DOMContentLoaded', boot);
    else boot();
  }
})(typeof window !== 'undefined' ? window : globalThis);
